var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FlyerlineModal",
    {
      ref: "modalRef",
      staticClass: "config-modal",
      attrs: { name: "sorten-verteilung-table" },
    },
    [
      _c("div", { staticClass: "bg-shade-light" }, [
        _c(
          "div",
          {
            staticClass:
              "bg-transparent config-group-outline px-prj2 py-prj px-3@large border mt-prj3 flex flex-column gap-4",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex mt-2 p-2 bg-secondary text-white text-small line-height-12",
              },
              [
                _c(
                  "svg",
                  {
                    staticClass:
                      "fill-secondary mr-2 svg-icon flex-child-fix position-relative t-1px",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 36 36",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { cx: "18", cy: "18", r: "18", fill: "#fff" },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                        fill: "#e94d47",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("translate")(
                        "txtUploadFiles",
                        _vm.globalConfig.shop.currency
                      )
                    )
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "w-full table--bordered",
                staticStyle: { "grid-template-columns": "repeat(4, 1fr)" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "bg-shade-light" }),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("txtSortenDescription"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("txtSortenQuantity")) +
                          " (" +
                          _vm._s(_vm.numAuflagen) +
                          " " +
                          _vm._s(_vm._f("translate")("txtPieces")) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm._f("translate")("txtUploadPrintFile"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.sortenData.entries(), function ([index, sorte]) {
                    return _c("tr", [
                      _c("td", { staticClass: "bg-shade-light" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("translate")("txtVariant")) +
                            " " +
                            _vm._s(index + 1) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          ref: "sortenVariantIdentifierRefs",
                          refInFor: true,
                          attrs: { type: "string" },
                          domProps: {
                            value: _vm.sortenData[index]?.variantIdentifier
                              ? _vm.sortenData[index]?.variantIdentifier
                              : "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.updateSortenEntry(index)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          ref: "sortenAmountRefs",
                          refInFor: true,
                          staticClass: "text-center",
                          attrs: { type: "number" },
                          domProps: {
                            value: _vm.sortenData[index]?.num
                              ? _vm.sortenData[index]?.num
                              : 0,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.updateSortenEntry(index)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("SkyUploadWrapper", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !sorte.fileName,
                                expression: "!sorte.fileName",
                              },
                            ],
                            ref: "sortenFileUploadRef",
                            refInFor: true,
                            attrs: {
                              fileuploadid: "sorte-upload-" + index,
                              "upload-file-extensions":
                                _vm.globalConfig.uploadFileExtensions,
                              multiple: false,
                              inline: true,
                              expanded: true,
                            },
                            on: {
                              fileUploadProgressStateChanged: function (
                                $event
                              ) {
                                return _vm.fileUploadProgressStateChanged(
                                  index,
                                  $event
                                )
                              },
                              fileschanged: function ($event) {
                                return _vm.filesChanged(index)
                              },
                              uploadFinished: function ($event) {
                                return _vm.fileUploaded(index, $event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          sorte.fileName
                            ? _c("div", { staticClass: "file-list" }, [
                                _c(
                                  "div",
                                  { staticClass: "small-12 column" },
                                  [
                                    _c("PrintFile", {
                                      attrs: {
                                        compact: "true",
                                        filename: sorte.fileName,
                                        fileid: sorte.fileIdentifier,
                                        filestatus:
                                          sorte.isFileFieldValid ===
                                            undefined || sorte.isFileFieldValid
                                            ? _vm.FILESTATUS.OK
                                            : _vm.FILESTATUS.ERROR_FILETYPE,
                                        file: null,
                                        url: null,
                                      },
                                      on: {
                                        "delete-file": function ($event) {
                                          return _vm.deleteFile(index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.pristine === false &&
                      ((sorte?.isTitleFieldValid === false &&
                        !!sorte?.titleFieldMessage) ||
                        (sorte?.isFileFieldValid === false &&
                          !!sorte?.fileFieldMessage))
                        ? _c("td", { staticClass: "spanned" }, [
                            !!sorte?.titleFieldMessage
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "py-1 px-2 bg-error text-white w-100 text-small",
                                  },
                                  [
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(sorte?.titleFieldMessage)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !!sorte?.fileFieldMessage
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "py-1 px-2 bg-error text-white w-100 text-small",
                                  },
                                  [
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(_vm._s(sorte?.fileFieldMessage)),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _c("td", { staticClass: "bg-shade-light" }, [
                      _vm._v(_vm._s(_vm._f("translate")("txtTotal"))),
                    ]),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.totalAmount) +
                          " " +
                          _vm._s(_vm._f("translate")("txtPieces"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn w-100",
                          attrs: {
                            disabled:
                              _vm.uploadInProgress ||
                              (!_vm.pristine && !_vm.isValid),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm._f("translate")("txtSave")))]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "bg-shade-light" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("translate")(
                            "txtVersandaufteilungRemainingPieces"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td", { class: { error: _vm.remainingAmount < 0 } }, [
                      _vm._v(
                        _vm._s(_vm.remainingAmount) +
                          " " +
                          _vm._s(_vm._f("translate")("txtPieces"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td"),
                  ]),
                  _vm._v(" "),
                  _vm.pristine === false && !!_vm.overallMessage
                    ? _c("tr", [
                        _c("td", { staticClass: "spanned" }, [
                          _c(
                            "div",
                            { staticClass: "py-1 px-2 error text-small" },
                            [
                              _c("ul", [
                                _c("li", [_vm._v(_vm._s(_vm.overallMessage))]),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }